import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Pipe({
  name: 'floor',
  pure: true
})
export class FloorPipe implements PipeTransform {
  constructor(private currencyPipe: CurrencyPipe){

  }

  transform(value: number): number {
    // var a = value;
    // var b = a.toString().substring(0, a.toString().indexOf(".") + 4)
    // console.log(b);
    // return parseFloat(b);

    return parseFloat(this.currencyPipe.transform(value, 'USD', undefined, '1.2-2'));
  }

}
